export default {
  methods: {
    alertSetAccount(callback) {
      this.$confirm(this.$t('components.alert.bindAccount.content'), this.$t('components.alert.bindAccount.title'), {
        confirmButtonText: this.$t('components.alert.bindAccount.confirm'),
        customClass: 'confirm',
        showCancelButton: true,
      })
        .then(() => {
          if (typeof callback === 'function') {
            callback()
          }
        })
        .catch(() => {})
    },
  },
}
